<!--
    select-on-tab
    (forge-autocomplete-change)="valueChange($event)"
-->
<!-- TODO: Update to forge-autocomplete when upgraded to Angular 8+ -->
<!-- <form [formGroup]="typeAheadFormGroup">
    <forge-autocomplete #autocomplete [formControlName]="searchTextControlName" [filter]="filterListener"
                      [highlightFirst]="autoActiveFirstOption">
        <forge-text-field [invalid]="isInvalid" [required]="isRequired">
            <input type="text" #typeahead>
            <label *ngIf="!hideLabel">{{label}}</label>
            <span slot="helper-text" *ngIf="hasError('required')">{{label}} is required</span>

            <span slot="helper-text">{{getDisplayValue(formControl.value)}}</span>

            <span *ngIf="hasCustomValidators">
                <span slot="helper-text" *ngFor="let customError of customErrors">
                    <span *ngIf="showErrorMessage(customError.errorKey)">
                        {{customError.message}}
                    </span>
                </span>
            </span>
        </forge-text-field>
    </forge-autocomplete>
</form> -->

<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small">
    <input #typeahead type="text" [formControl]="searchTextControl" [matAutocomplete]="dropdown"
           [attr.telemetry]="label">

    <forge-icon-button *ngIf="hasIcon" slot="end" dense (click)="iconActionClick()">
        <forge-tooltip>{{iconTooltip}}</forge-tooltip>
        <forge-icon [name]="iconName"></forge-icon>
    </forge-icon-button>

    <label slot="label" *ngIf="!hideLabel">{{label}}</label>

    <mat-autocomplete #dropdown="matAutocomplete" [displayWith]="getDisplayValueFn()"
                      [autoActiveFirstOption]="autoActiveFirstOption" panelWidth="auto">
        <mat-option *ngFor="let option of options" [value]="getValue(option)">
            <span [innerHTML]="getDisplayValue(option) | highlight: searchInputText">
            </span>
        </mat-option>
    </mat-autocomplete>

    <span slot="support-text" *ngIf="hasError('required')">
        {{label}} is required
    </span>

    <span slot="support-text" *ngIf="helperTextSpacer"></span>

    <span *ngIf="hasCustomValidators">
        <span slot="support-text" *ngFor="let customError of customErrors">
            <span *ngIf="hasError(customError.errorKey)">
                {{customError.message}}
            </span>
        </span>
    </span>
</forge-text-field>